import posthog from 'posthog-js';
import { history } from 'umi';

const POSTHOG_API_HOST = 'https://ph.bluemediagroup.cn';
const POSTHOG_API_CONFIG = {
  production: {
    apiKey: 'phc_GhiOJFNoZpgsJHca3zIlLWUtD3somqmSj1gM2SwCR34',
  },
  development: {
    apiKey: 'phc_MLPfHB4VVq8p8Zss0HEOrxHcwT4mZfN1zlpCgd91nsG',
  },
};
// 根据域名判断环境
const isProduction =
  typeof window !== 'undefined' && window.location.hostname === 'back.bluemediagroup.cn';
const apiKey = isProduction
  ? POSTHOG_API_CONFIG.production.apiKey
  : POSTHOG_API_CONFIG.development.apiKey;

// PostHog 配置
const POSTHOG_CONFIG = {
  apiKey,
  api_host: POSTHOG_API_HOST, // 私有化部署替换为你的地址
  capturePageview: false, // 关闭默认页面浏览捕获（后续手动结合 Umi 路由处理）
  capturePageleave: true,
  autocapture: true, // 自动捕获点击、输入等行为（可选，根据需求关闭）
  disable_session_recording: true,
};

// 初始化 PostHog
export const initPostHog = () => {
  if (typeof window !== 'undefined' && !posthog.__loaded) {
    posthog.init(POSTHOG_CONFIG.apiKey, {
      ...POSTHOG_CONFIG,
      // 结合 Umi history 监听路由，确保页面跳转时正确上报
      loaded: (ph) => {
        // 监听路由变化，上报页面浏览
        history.listen(({ pathname, query }) => {
          ph.capture('$pageview', {
            pathname,
            query,
            referrer: document.referrer,
            title: document.title,
          });
        });
      },
    });
  }
};

// 手动埋点事件
export const posthogCapture = (eventName: string, properties?: Record<string, unknown>) => {
  if (posthog?.__loaded) {
    posthog.capture(eventName, properties);
  }
};

// 设置用户标识（登录后调用）
export const identifyUser = (userId?: string, userProperties?: Record<string, unknown>) => {
  if (posthog.__loaded) {
    posthog.identify(userId, userProperties);
  }
};

// 清除用户标识（登出后调用）
export const resetPosthogUser = () => {
  if (posthog.__loaded) {
    posthog.reset();
  }
};

// 手动埋点事件
export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  // posthog上报
  posthogCapture(eventName, properties);
};

// 导出原始实例（备用）
export default posthog;
